export default __webpack_public_path__ + "static/media/Q3-yes.e7fce012.png";